import { z, ZodSchema, SafeParseReturnType } from "zod";

// Input fields validation
export const requiredString = (message: string) => {
  return z.string({ required_error: message });
};
export const requiredNumber = (required: string, invalid: string) => {
  return z.number({
    required_error: required,
    invalid_type_error: invalid,
    message: invalid,
  });
};
export const optionalNumber = (invalid: string) => {
  return z.string().regex(numberRegExp, invalid).optional();
};
export const requiredDate = (message: string) => {
  return z.date({ required_error: message });
};

const numberRegExp = /^[0-9]+$/;

export const privacy = (message: string) => {
  return z
    .boolean({ required_error: message })
    .refine((value) => value === true, {
      message: message,
    });
};

export const e_mail = (required: string, invalid: string) => {
  return z.string({ required_error: required }).email({ message: invalid });
};
export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const phoneNumber = (message: string) => {
  return z.string().regex(phoneRegExp, message).optional();
};
export const requiredPhoneNumber = (required: string, invalid: string) => {
  return z.string({ required_error: required }).regex(phoneRegExp, invalid);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safeParseSchema = <T>(schema: ZodSchema, data: any) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result: SafeParseReturnType<any, T> = schema.safeParse(data);

  if (!result.success) {
    return {
      flattenedErrors: result.error.flatten().fieldErrors,
    };
  } else {
    return { data: result.data, flattenedErrors: {} };
  }
};
